export default __webpack_public_path__ + "static/media/forestly-expl-dissect-05_EN.3917fc53.png";